module.exports = __webpack_public_path__ + "static/media/trevor_chuna.181c7786.png";